"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// Styles
var Sup = (0, _core.styled)('sup')({
  fontSize: '50%',
  verticalAlign: 'super',
  '&.with-space': {
    '&--left': {
      marginLeft: '0.125em'
    },
    '&--right': {
      marginRight: '0.125em'
    }
  },
  '&:empty': {
    display: 'none'
  }
});
var Span = (0, _core.styled)('span')({
  position: 'relative',
  '&.disabled-sup': {
    '& sup': {
      fontSize: 'inherit',
      verticalAlign: 'inherit'
    }
  }
});
var PriceSpan = (0, _core.styled)('span')({
  '&.strike-through': {
    textDecoration: 'underline',
    textUnderlineOffset: '-0.325em',
    textDecorationSkipInk: 'none'
  }
}); // Helpers

var getPriceStrings = function getPriceStrings(_price) {
  try {
    var price;
    if (typeof _price === 'string') {
      price = Number((_price[0] === '$' ? _price.slice(1) : _price).replace(',', '')).toFixed(2);
    } else {
      price = Number(_price).toFixed(2);
    }
    var result = price.split('.');
    if (result[1] === '00' || result[1] === '0') {
      return [result[0]];
    }
    return result;
  } catch (_unused) {
    return ['Invalid Price'];
  }
};
/**
 * @deprecated use @rtg2022/components/atoms/Price/Price.jsx instead
 */

var PriceAtom = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var className = _ref.className,
    price = _ref.price,
    disableSuperscript = _ref.disableSuperscript,
    strikeThrough = _ref.strikeThrough;
  var _getPriceStrings = getPriceStrings(price),
    _getPriceStrings2 = _slicedToArray(_getPriceStrings, 2),
    dollars = _getPriceStrings2[0],
    cents = _getPriceStrings2[1];
  return /*#__PURE__*/_react.default.createElement(Span, {
    className: (0, _clsx.default)(className, disableSuperscript && 'disabled-sup')
  }, /*#__PURE__*/_react.default.createElement(PriceSpan, {
    className: (0, _clsx.default)(strikeThrough && 'strike-through')
  }, /*#__PURE__*/_react.default.createElement(Sup, null, "$"), dollars), /*#__PURE__*/_react.default.createElement(Sup, {
    className: (0, _clsx.default)(!strikeThrough && 'with-space--left')
  }, cents && disableSuperscript && /*#__PURE__*/_react.default.createElement("span", null, "."), cents));
});
var _default = PriceAtom;
exports.default = _default;